import { render, staticRenderFns } from "./pidMasterDetail.vue?vue&type=template&id=b8c6403e"
import script from "./pidMasterDetail.vue?vue&type=script&lang=js"
export * from "./pidMasterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8c6403e')) {
      api.createRecord('b8c6403e', component.options)
    } else {
      api.reload('b8c6403e', component.options)
    }
    module.hot.accept("./pidMasterDetail.vue?vue&type=template&id=b8c6403e", function () {
      api.rerender('b8c6403e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/pidMasterDetail.vue"
export default component.exports